export interface ComponentCallback<T> { (m:T): void }
export const logImpl = <T>() => (m) => { console.warn('Callback missing', m) }

